// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';


let today = new Date();
console.log(today);
today.setHours(0);
today.setMinutes(0);
today.setSeconds(0);
console.log(today);

$w.onReady(function () {
    // Write your JavaScript here

    // To select an element by ID use: $w("#elementID")

    // Click "Preview" to run your code

    $w('#eventsDataset').onReady(() => {
        // let today = new Date();
        // console.log(today);
        // today.setHours(0);
        // today.setMinutes(0);
        // today.setSeconds(0);
        // console.log(today);

        $w("#eventsDataset").setFilter(wixData.filter()
            .ge("dateTime", today)
            .ne("cancelled", true)
        );

    });

});

let rollOptions = {
  "duration":   2500,
  "delay":      1000
};

export function closedBannerButton_click(event) {

	// Add your code for this event here: 
	$w('#closedBanner').hide("fade");
	// $w('#welcomeText').show("roll", rollOptions)

}

export function fullWidthPullSection1_viewportEnter(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	// $w('#fullWidthPullText1').show("fade");
}

export function fullWidthPullImage2_viewportEnter(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	
}

export function fullWidthPullSection2_viewportEnter(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	// $w('#fullWidthPullText2').show("fade");
	// $w('#fullWidthPullImage2').show("fade");
}